(function($, Drupal, drupalSettings, window, document, undefined) {
    Drupal.behaviors.map = {
      attach: function(context, settings) {
        $('ul#map-wrapper li')
        .mousemove(function(e) {
          var cons = $(this).data('cons');

          var offset = $("#csmap").offset();

          var ctop = offset.top;
          var cleft = offset.left;

          //console.log('Top : '+ctop+' , Left : '+cleft);

          $('#wrapper-' + cons).show()
          .css('top', e.pageY - ctop + 25)
          .css('left', e.pageX - cleft + 25);
        })
        .mouseout(function(e) {
          $('.wrapper-cons').hide();
        });

        $('.marker').on('click',function(event){
          $('.dtl').removeClass('activedt');
            $(this).next('.dtl').toggleClass('activedt');
            event.stopPropagation();
        });

        $(window).click(function() {
          if($('.activedt').length > 0)
          {
            $('.dtl').removeClass('activedt');
          }
        });


      }
    }
  })(jQuery, Drupal, drupalSettings, this, this.document);
  